import { render, staticRenderFns } from "./conversationsDetail.vue?vue&type=template&id=369f0742&scoped=true&"
import script from "./conversationsDetail.vue?vue&type=script&lang=js&"
export * from "./conversationsDetail.vue?vue&type=script&lang=js&"
import style0 from "./conversationsDetail.vue?vue&type=style&index=0&id=369f0742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369f0742",
  null
  
)

export default component.exports